import { gql, type TypedDocumentNode } from "@apollo/client";

export interface PatResultVolumeYear {
  year: number;
  passedCount: number;
  failedCount: number;
  qualifiedCount: number;
  lookerFailCount: number;
  scoredCount: number;
  pendingCount: number;
  distinctPassedPeopleCount: number;
  distinctFailedPeopleCount: number;
  neverSyncedCount: number;
}

export interface PatResultVolumeAttemptBucket {
  attemptCount: number;
  label: string;
  passedPeopleCount: number;
}

export interface PatResultVolume {
  years: PatResultVolumeYear[];
  maxBeginDate?: string | null;
  maxSubmittedAt?: string | null;
  maxUpdatedAt?: string | null;
  passedByAttempt: PatResultVolumeAttemptBucket[];
  firstPassBeforeMembershipStartCount: number;
  firstPassAfterMembershipStartCount: number;
  ccmsHistoricalScoredCount: number;
}

export interface PatResultVolumeQueryResponse {
  patResultVolume: PatResultVolume;
}

export const PAT_RESULT_VOLUME_QUERY: TypedDocumentNode<PatResultVolumeQueryResponse, Record<string, never>> = gql`
  query PatResultVolume {
    patResultVolume {
      maxBeginDate
      maxSubmittedAt
      maxUpdatedAt
      firstPassBeforeMembershipStartCount
      firstPassAfterMembershipStartCount
      ccmsHistoricalScoredCount
      passedByAttempt {
        attemptCount
        label
        passedPeopleCount
      }
      years {
        year
        passedCount
        failedCount
        qualifiedCount
        lookerFailCount
        scoredCount
        pendingCount
        distinctPassedPeopleCount
        distinctFailedPeopleCount
        neverSyncedCount
      }
    }
  }
`;
